import $ from 'jquery';

export default function articlesFeatureEnhance() {
  $('.roc-articles-feature').each(function () {
    const $section = $(this);
    const $media = $section.find('.roc-articles-feature__media.has-video').first();
    const $playBtn = $section.find('.roc-articles-feature__play').first();
    const $ctaBtn = $section.find('.roc-articles-feature__cta-play').first();
    const $sidebarItems = $section.find('.roc-articles-feature__sidebar-item');

    $section.addClass('is-enhanced');

    function startEmbeddedMedia() {
      if (!$media.length) {
        return;
      }

      const $videoContainer = $media.find('.roc-articles-feature__video-container');
      const $htmlVideo = $videoContainer.find('video');
      const $iframe = $videoContainer.find('iframe');

      // HTML5 video
      if ($htmlVideo.length) {
        $htmlVideo.each(function () {
          this.muted = true; // helps autoplay in many browsers
          const playPromise = this.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              // ignore autoplay rejection silently
            });
          }
        });
      }

      // YouTube / Vimeo iframe
      if ($iframe.length) {
        $iframe.each(function () {
          const $this = $(this);
          const src = $this.attr('src');

          if (src) {
            // reset src on click so autoplay actually starts when revealed
            $this.attr('src', src);
          }
        });
      }
    }

    function playVideo(e) {
      if (e) {
        e.preventDefault();
      }

      if (!$media.length || $media.hasClass('is-playing')) {
        return;
      }

      $media.addClass('is-playing');
      $section.addClass('is-video-active');

      startEmbeddedMedia();
    }

    if ($playBtn.length) {
      $playBtn.on('click', playVideo);
    }

    if ($ctaBtn.length) {
      $ctaBtn.on('click', playVideo);
    }

    $sidebarItems.each(function (index) {
      $(this).css('transition-delay', `${index * 40}ms`);
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              $section.addClass('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2,
        }
      );

      observer.observe($section[0]);
    } else {
      $section.addClass('is-visible');
    }
  });
}